import { Route, Routes } from 'react-router-dom';
import { Login, Register, ForgotPassword, ResetPassword } from './component';
import { AuthProvider } from '../../providers';

const routes = () => {
  return (
    <Routes>
      <Route element={<AuthProvider />}>
        <Route path='login' element={<Login />} />
        <Route path='register' element={<Register />} />
        <Route path='forgot_password' element={<ForgotPassword />} />
        <Route path='reset_password' element={<ResetPassword />} />
      </Route>
    </Routes>
  );
};

export default routes;
